const columnsVariant: Record<string, string> = {
  1: "grid grid-cols-1 gap-3 sm:gap-5",
  2: "grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-5",
  3: "grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 sm:gap-5",
  4: "grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4 sm:gap-5",
  5: "grid grid-cols-1 gap-3 sm:grid-cols-3 md:grid-cols-5 sm:gap-5",
  6: "grid grid-cols-1 gap-3 sm:grid-cols-3 md:grid-cols-6 sm:gap-5",
};

export const colVariant = (colKey: number): string => {
  return columnsVariant[colKey] || "grid grid-cols-1";
};
